<template>
  <nav class="ui left fixed vertical menu fuzzy-list">
    <Spinny :tablesPromise="tablesPromise" />
    <Placy
      v-if="!items || !items.length"
      :promise="tablesPromise"
      :empty-message="$t('NO_THING_YET', { thing: $tc('TABLE', 2) })"
      :error-message="$t('ERR', { action: $t('READ', { thing: $tc('TABLE', 2) }) })"
    />

    <!-- Search -->
    <div class="item" v-if="items && items.length > 10">
      <div class="ui icon input">
        <input
          type="text"
          :placeholder="$t('SEARCH')"
          v-model="searchTerm"
          autocomplete="off"
          @keydown.esc="searchTerm = ''"
        />
        <i class="search icon"></i>
      </div>
    </div>

    <router-link class="item" :to="{ name: 'new-table' }">
      <i class="plus icon"></i>
      <strong>{{ $t('NEW', { thing: $tc('TABLE', 1) }) }}</strong>
    </router-link>

    <router-link
      class="item"
      :active-class="'active'"
      :to="{ name: 'table-home', params: { tableId: table.original.id } }"
      v-for="table in filteredItems"
      :key="table.original.id"
    >
      <div class="name ellipsis" :title="table.original.name" v-html="table.string" />
    </router-link>
  </nav>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';

nav {
  overflow-y: scroll;
}

.name {
  padding: 0 0 5px 0;
}
</style>

<script>
// @flow
import { Spinny, Placy } from 'ui'
import { Table } from 'services'
import FuzzyFilterer from '../Mixins/FuzzyFilterer'

export default {
  name: 'table-list',
  components: { Spinny, Placy },
  mixins: [FuzzyFilterer],

  data() {
    return {
      tablesPromise: null
    }
  },

  computed: {
    items() {
      return this.$store.state.table.items
    }
  },

  created() {
    this.tablesPromise = Table.readAllTables()
  }
}
</script>
